import PropTypes from 'prop-types';
import cx from "ramda-extension/es/cx";
import React from 'react';
import ExclamationCircle from '../../../atoms/SvgIcon/Icons/ExclamationCircle';
import { useDefaultComponentValue } from '../../../utils/useDefaultComponentValue';
import Tooltip from '../../Tooltip';
const COMPONENT_NAME = 'TooltipValidation';
const TooltipValidation = (inProps)=>{
    const props = useDefaultComponentValue({
        inProps,
        name: COMPONENT_NAME
    });
    const { validationClassName, validationText, tooltipComponent: TooltipComponent = Tooltip } = props;
    return /*#__PURE__*/ React.createElement(TooltipComponent, {
        className: cx('TooltipValidation', validationClassName),
        children: validationText,
        hideIcon: true,
        tip: /*#__PURE__*/ React.createElement(ExclamationCircle, null)
    });
};
TooltipValidation.propTypes = {
    tooltipComponent: PropTypes.any,
    validationClassName: PropTypes.string,
    validationText: PropTypes.string
};
export default TooltipValidation;
